module.exports = __webpack_public_path__ + "static/media/xmas2022.223c6ed3.png";